import Bird from './Bird';

export default Bird;
